/** Bump when persisted preview shape changes (drops incompatible localStorage). */
const SCHEMA_VERSION = 2;
const KEY_PREFIX = 'qapp_finance_flow_download_preview';

export function downloadPreviewStorageKey(userId) {
  const id = userId != null && userId !== '' ? String(userId) : 'anon';
  return `${KEY_PREFIX}_v${SCHEMA_VERSION}_${id}`;
}

/**
 * @returns {object | null}
 */
export function loadDownloadPreviewSnapshot(userId) {
  try {
    const raw = localStorage.getItem(downloadPreviewStorageKey(userId));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.schemaVersion !== SCHEMA_VERSION) return null;
    if (!data.openfinanceData || typeof data.openfinanceData !== 'object') return null;
    return data;
  } catch {
    return null;
  }
}

/**
 * @param {string|number} userId
 * @param {object} snapshot — serializable fields only (no File)
 */
export function saveDownloadPreviewSnapshot(userId, snapshot) {
  const payload = {
    schemaVersion: SCHEMA_VERSION,
    ...snapshot,
  };
  const json = JSON.stringify(payload);
  localStorage.setItem(downloadPreviewStorageKey(userId), json);
}

export function clearDownloadPreviewSnapshot(userId) {
  try {
    localStorage.removeItem(downloadPreviewStorageKey(userId));
  } catch {
    /* ignore */
  }
}
